const authoritiesToExclude = [
  // Hide ALL authorities pre-assigned to RC or FA
  'AUTH_WRITE_USER_PHONE_AND_ADDRESS',
  'AUTH_DELETE_USER_PHONE_AND_ADDRESS',
  'AUTH_READ_CATEGORY',
  'AUTH_READ_DOCUMENT',
  'AUTH_READ_DOCUMENT_TYPE',
  'AUTH_READ_FUND',
  'AUTH_READ_FUND_FAMILY',
  'AUTH_READ_GROUP',
  'AUTH_READ_INVESTOR',
  'AUTH_READ_INVESTOR_ORGANIZATION',
  'AUTH_READ_USER',
  'AUTH_RC_SENDMAIL',
  'AUTH_WRITE_CONTACTUS',
  'AUTH_WRITE_USER_ACTIVITY',
  'AUTH_ACCEPT_FUND_TERMS',
  'AUTH_READ_TENANT_CONFIGURATION',
  'AUTH_READ_USER_AUTHORIZATION',
  'AUTH_READ_RESOURCE_UPLOAD',
  'AUTH_READ_SPLIT_METHOD',
  'AUTH_READ_DOCUMENT_PRESET',
  'AUTH_READ_DOCUMENT_WATERMARK',
  'AUTH_READ_DOCUMENT_SECURITY',
  'AUTH_READ_ROLE',
  'AUTH_READ_MAIL_TEMPLATE',
  'AUTH_READ_FUND_TERM_AND_CONDITION',
  'AUTH_READ_CATEGORY_TERM_AND_CONDITION',
  'AUTH_READ_AUDIT',
  'AUTH_READ_MFA',
  'AUTH_WRITE_OPPORTUNITY',
  'AUTH_WRITE_LOG',
  'AUTH_READ_FUND_TAG',
  'AUTH_READ_INVESTOR_TAG',
  'AUTH_READ_FUND_INVESTOR_TAG',
  'AUTH_READ_USER_ACTIVITIES',
  'AUTH_EDIT_USER_WELCOME_EMAIL_FLAG',
  // Hide the following authorities for actions not allowed anymore
  'AUTH_DELETE_GROUP',
  'AUTH_DELETE_CATEGORY',
  // Hide the following authorities until we add the related features
  'AUTH_READ_AUDIT_NA'
];

export { authoritiesToExclude };
